import(/* webpackMode: "eager" */ "/my-new-test/app/global-error.tsx")